var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSnx = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 30,
    viewBox: "0 0 45 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.246 6.965a1.4 1.4 0 0 0-1.096-.508H.266a.257.257 0 0 1-.192-.075A.228.228 0 0 1 0 6.218V.239A.23.23 0 0 1 .074.075.257.257 0 0 1 .266 0h9.388c2.369 0 4.412.967 6.13 2.9l2.28 2.78-4.442 5.41-3.376-4.125ZM26.653 2.87C28.37.957 30.423 0 32.813 0h9.357c.08 0 .138.02.178.06.04.04.06.1.06.179v5.979c0 .06-.02.115-.06.164-.04.05-.099.075-.178.075h-8.884c-.434 0-.799.17-1.095.508l-6.545 7.952 6.574 8.01c.297.32.651.48 1.066.48h8.884c.08 0 .138.024.178.074.04.05.06.115.06.194v5.979c0 .06-.02.115-.06.164-.04.05-.099.075-.178.075h-9.358c-2.388 0-4.432-.966-6.13-2.9l-5.448-6.636-5.45 6.636c-1.718 1.934-3.77 2.9-6.16 2.9H.266c-.079 0-.138-.025-.178-.075a.301.301 0 0 1-.059-.195v-5.979c0-.059.02-.114.06-.164.039-.05.098-.074.177-.074H9.15c.415 0 .78-.17 1.096-.509l6.426-7.831 9.98-12.196Z",
    fill: "#00DCFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.246 6.965a1.4 1.4 0 0 0-1.096-.508H.266a.257.257 0 0 1-.192-.075A.228.228 0 0 1 0 6.218V.239A.23.23 0 0 1 .074.075.257.257 0 0 1 .266 0h9.388c2.369 0 4.412.967 6.13 2.9l2.28 2.78-4.442 5.41-3.376-4.125ZM26.653 2.87C28.37.957 30.423 0 32.813 0h9.357c.08 0 .138.02.178.06.04.04.06.1.06.179v5.979c0 .06-.02.115-.06.164-.04.05-.099.075-.178.075h-8.884c-.434 0-.799.17-1.095.508l-6.545 7.952 6.574 8.01c.297.32.651.48 1.066.48h8.884c.08 0 .138.024.178.074.04.05.06.115.06.194v5.979c0 .06-.02.115-.06.164-.04.05-.099.075-.178.075h-9.358c-2.388 0-4.432-.966-6.13-2.9l-5.448-6.636-5.45 6.636c-1.718 1.934-3.77 2.9-6.16 2.9H.266c-.079 0-.138-.025-.178-.075a.301.301 0 0 1-.059-.195v-5.979c0-.059.02-.114.06-.164.039-.05.098-.074.177-.074H9.15c.415 0 .78-.17 1.096-.509l6.426-7.831 9.98-12.196Z",
    fill: "#00D1FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h45v30H0z"
  })))));
};
export default SvgSnx;